// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFields = {
  id: "ID",
  userId: "User ID",
  username: "Username",
  displayName: "Display Name",
  role: "Role",
  status: "Status",
  type: "Type",
  examId: "Exam ID",
  attemptId: "Attempt ID",
  module: "Module",
  action: "Action",
  resource: "Resource",
  resourceType: "Resource Type",
  resourceId: "Resource ID",
  relation: "Relation",
  sequenceNo: "Question No.",
  order: "Order",
  limit: "Limit",
  difficulty: "Difficulty",
  code: "Code",
  identifier: "Identifier",
  name: "Name",
  description: "Description",
  title: "Title",
  organization: "Organization",
  organizationUnit: "Organization Unit",
  phone: "Phone",
  expiresAt: "Expires At",
  platformRoles: "Platform Roles",
  applicationRolesSummary: "Application Role Summary",
  organizationMemberships: "Organization Memberships",
  platformRoleAssignments: "Platform Role Assignment Details",
  paperType: "Paper Type",
  questionType: "Question Type",
  questionCount: "Question Count",
  totalScore: "Total Score",
  durationMinutes: "Suggested Duration",
  field: "Field",
  fromValue: "Old Value",
  toValue: "New Value",
  jsonField: "JSON Field",
  path: "Path",
  changeType: "Change Type",
  versionNo: "Version",
  versionedCode: "Versioned Code",
  verdict: "Verdict",
  judgeStatus: "Judge Status",
  language: "Language",
  score: "Score",
  passedCases: "Passed Cases",
  stdout: "stdout",
  stderr: "stderr",
  createdBy: "Created By",
  createdAt: "Created At",
  updatedBy: "Updated By",
  updatedAt: "Updated At",
  actions: "Actions",
} as const;
